import { Camera, Plane, Vector3 } from 'three';

export function getCameraAlignedDragPlane(
  camera: Camera,
  worldPoint: Vector3
): Plane {
  const viewDirection = camera.getWorldDirection(new Vector3());
  const absX = Math.abs(viewDirection.x);
  const absY = Math.abs(viewDirection.y);
  const absZ = Math.abs(viewDirection.z);

  const normal = new Vector3(0, 0, 1);
  if (absY >= absX && absY >= absZ) {
    normal.set(0, 1, 0);
  } else if (absX >= absZ) {
    normal.set(1, 0, 0);
  }

  return new Plane().setFromNormalAndCoplanarPoint(normal, worldPoint);
}
